import BaseAPI from './BaseAPI';

// Timesheets — the week read as payroll. Under /timesheets, admin only.
class TimesheetsAPI extends BaseAPI {
  constructor() { super('timesheets'); }

  // GET /timesheets?start=&end=&location= → { people, totals }
  // Worked out live from shifts and schedules; an approved week also carries
  // the figures as they stood when it was signed off.
  week(start, end, location) {
    const q = new URLSearchParams({ start, end });
    if (location) q.set('location', location);
    return this.get(`/?${q.toString()}`);
  }

  // GET /timesheets/day?date= → { people, totals }
  // One day as a column per technician: planned against clocked.
  day(date, location) {
    const q = new URLSearchParams({ date });
    if (location) q.set('location', location);
    return this.get(`/day?${q.toString()}`);
  }

  // GET /timesheets/:idStaff?start=&end= → { worked, scheduled }
  detail(idStaff, start, end) {
    return this.get(`/${idStaff}?${new URLSearchParams({ start, end })}`);
  }

  approve(idStaff, periodStart, periodEnd, note) {
    return this.post('/approve', { body: { idStaff, periodStart, periodEnd, note } });
  }
  approveAll(periodStart, periodEnd, location) {
    return this.post('/approve-all', { body: { periodStart, periodEnd, location } });
  }
  unapprove(idStaff, periodStart) {
    return this.post('/unapprove', { body: { idStaff, periodStart } });
  }
}

export const TimesheetsService = new TimesheetsAPI();
export default TimesheetsAPI;
